import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.914 17.303c2.374 3.405 5.613 4.952 5.613 4.952s8.872-1.406 10.202-9.286c0 0 1.189-7.36.644-7.703-.584-.388-4.984-.051-8.84-4.221-4.566 3.32-8.545 2.137-9.15 2.405 0 0-1.189 4.506.05 8.044"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.122 6.616a1.616 1.616 0 1 1 3.232 0M6.943 11.062c.01-2.07 1.332-3.785 3.178-4.446v1.415M13.354 8.03V6.617c1.846.66 3.168 2.375 3.178 4.446M17.276 11.06H6.2M11.737 17.678a4.25 4.25 0 0 1-4.252-4.253V11.06h8.504v2.365a4.25 4.25 0 0 1-4.252 4.253"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ShieldWorkIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
